import ApiService from '@/services/ApiService';

const namespace = 'users/confirmation';

const confirm = (code, callback, errorCallback) => {
    ApiService.get(`${namespace}/${code}`, {}, callback, errorCallback, { overrideAuthRefresh: true });
};

const resend = (id, callback, errorCallback) => {
    ApiService.post(`${namespace}/${id}/resend`, {}, callback, errorCallback);
};

export default {
    confirm,
    resend,
};



// WEBPACK FOOTER //
// ./src/taskflex/users/services/EmailConfirmationService.js